define('drops/autoComplete/autoComplete',[
    'jquery',
    'lq/drop',
    'lq/style',
    'lq/util',
    'lq/constants',
    'lq',
    'underscore',
    'lq/tooltip',
    'lq/html',
    'lq/required',
    'drops/modals',
    'lq/dynamicContentImage',
    'lq/dropDownsListPositioning'
], function($, Drop, style, util, constants, lq, _, Tooltip, html, Required, modals, dynamicContentImage, dropDownsListPositioning) {
    'use strict';

    var generateRandomSuffix = function(length) {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < length; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));

        return text;
    };

    var defaults = {
        data: {
            filterParameterName: '',
            keyOutputName: 'Id',
            behaviour: 'dropdown',
            onlyShowSelectedItem: true,
            title: {
                option: Tooltip.hardcoded
            },
            required: {
                initialVisibility: true,
                isRequired: false,
                valueSource: 'hardcoded'
            }
        }
    };

    var offsetToTheEdge = 10;
    var offsetFromInput = 4;
    var defMaxHeight = 400;

    var ARROWDOWN = 40;
    var ARROWUP = 38;
    var ENTER = 13;
    var TAB = 9;

    function AutoComplete(options) {
        Drop.call(this, $('<div />'), defaults, options);

        this.data.eventing = util.convertListOfKeyValuesToObject(this.data.eventing);

        this.typeOfCurrentValue = constants.valueTypes.string;
        this.focused = false;

        this.selectedItem = null;
        this.selectedId = null;
        this.selectedText = null;

        this.results = null;
        this.outputs = null;

        this.afterUpdate = null;

        this.hasSearch = this.data.behaviour === 'dropdown-with-search';

        this.$element
            .css({
                whiteSpace: 'pre-wrap'
            });

        this.$list = $('<div />')
            .addClass('auto-complete-popup')
            .addClass('prevent-hover')
            .addClass('prevent-normal')
            .hide();

        this.currentPage = 0;
        this.fetchingPage = false;
        this.lastPageReached = true;
        this.blockInfiniteScroll = true;

        this.totalNumberOfResults = null;
        this.numberOfLoadedResults = null;

        this.$inputWrapper = $('<div id="IPW"/>')
            .addClass('auto-complete-input boxToBorderSize')
            .appendTo(this.hasSearch ? this.$list : this.$element);

        if (this.hasSearch) {
            this.$inputWrapper.addClass('prevent-normal prevent-hover')
        }

        this.$iconPermanent = $('<div class = "icon-permanent"/>');
        this.$icon = $('<div class = "icon"/>');

        this.$inputField = $('<input autocomplete="off" />')
            .addClass('inherit-all')
            .attr('name', (this.data.name || '') + '_' + generateRandomSuffix(10)) // add random suffix because depending on the version of Chrome autocomplete="off" might be ignored
            .appendTo(this.$inputWrapper);
        if (this.data.behaviour !== 'dropdown-with-search')
            this.$inputField.css({ padding: '0px' });

        this.$scrollContainer = $('<div class="list-of-results prevent-hover prevent-normal" />')
            .attr('id', this.data.id)
            .appendTo(this.$list);

        this.$listTable = $('<table />')
            .attr('id', this.data.id)
            .appendTo(this.$scrollContainer);

        this.$listFooter = $('<div class="list-footer pagerText" />')
            .appendTo(this.$list);

        this.tooltip = new Tooltip(this, this.data.title, this.$inputField);

        if (this.data.infiniteScroll) {
            this.onScroll = this.fetchNextPageIfNeeded.bind(this);
            this.$scrollContainer
                .on('scroll', this.onScroll);
        }

        this.$imgWrapper = $('<div />')
            .addClass('auto-complete-toggle-wrapper');

        if (this.hasSearch) {
            this.$displayField = $('<div />')
                .addClass('auto-complete-label auto-complete-label-placeholder')
                .text(this.data.watermark)
                .css({
                    position: 'relative',
                    width: '100%'
                });
            this.$clearButton = $('<div class="auto-complete-clear-button"></div>')
                .on('click', this.clearValue.bind(this))
                .appendTo(this.$imgWrapper);
            this.$borderWrapper = $("<div class = 'auto-complete-border-wrapper'/>")
                .css({
                    display: 'flex',
                    verticalAlign: 'middle',
                    justifyContent: 'space-between',
                    position: 'absolute',
                    inset: '0'
                })
                .append(this.$iconPermanent)
                .append(this.$icon)
                .append(this.$displayField);
            this.$element
                .prepend(
                    this.$borderWrapper
                );
            this.$borderWrapper.append(this.$imgWrapper);
        } else {
            this.$icon.prependTo(this.$inputWrapper);
            this.$iconPermanent.prependTo(this.$inputWrapper);
            this.$displayField = this.$inputField;
            this.$inputField.attr('placeholder', this.data.watermark);
            this.$imgWrapper.appendTo(this.$inputWrapper);
        }
        // NOTE: Empty icon should still be visible even if iconColumn is not set
        // BAB: I leave this commented code here to remind myself of that behaviour
        // if (!this.data.iconColumn)
            // this.$icon.css('display', 'none');

        this.$img = $('<div />')
            .toggle(this.isDropDown())
            .addClass('auto-complete-toggle')
            .appendTo(this.$imgWrapper);

        this.$displayField.attr('tabindex', this.data.tabIndex);

        this.renderStyles();
        this.tooglePlaceholder(true);

        if (!this.data.dataSource && !this.designData)
            this.$displayField.addClass('query-error').prop('placeholder', "Query error!");


        this.newSearchDebounced = _.debounce(this.newSearch.bind(this), 400);
        this.onScroll = _.debounce(this.newSearch.bind(this), 400);
    };

    Drop.extend(AutoComplete, Drop);

    AutoComplete.typeName = 'AutoComplete';

    AutoComplete.prototype.fetchNextPageIfNeeded = function () {
        if (this.lastPageReached || this.fetchingPage || this.blockInfiniteScroll)
            return;

        if (this.$scrollContainer.scrollTop() + this.$scrollContainer.height() >= this.$scrollContainer[0].scrollHeight - 30) {
            this.currentPage++;
            this.fetchingPage = true;

            var self = this;
            this.piping.queryDispatcher.dispatch(
                this.data.dataSource,
                function (data) {
                    self.fetchingPage = false;
                    self.update(data, false);
                },
                function (params) {
                    self.decorateQuery(params);
                });
        }
    };

    AutoComplete.prototype.isDropDown = function () {
        return this.data.behaviour === 'dropdown'
            || this.data.behaviour === 'dropdown-with-search';
    };

    AutoComplete.prototype.clearFilterParameter = function () {
        if (!this.data.filterParameterName)
            return;
        this.piping.parameters.locals.setValue(this.data.filterParameterName, '');
    };

    AutoComplete.prototype.tooglePlaceholder = function (isVisible) {
        var $wrapper = null
        var val = this.getValue();
        // If the bahaviour is not 'dropdown-with-search', the placeholder should disapear even if there is no selected value,
        // because the user input should be shown instead of the placeholder in that case
        var containsValues = val !== null && val !== undefined;
        var hasValueTypedin =
            containsValues ||
            this.data.behaviour !== 'dropdown-with-search' && !!this.$inputField.val().length;

        if (isVisible) {
            if (this.hasSearch) {
                this.$borderWrapper.addClass('has-placeholder');
                this.$borderWrapper.addClass('empty');
                this.$inputWrapper.addClass('prevent-hover');
                $wrapper = this.$borderWrapper;
            } else {
                this.$inputWrapper.addClass('has-placeholder');
                this.$inputWrapper.addClass('empty');
                $wrapper = this.$inputWrapper;
            }
        } else if (hasValueTypedin) {
            if (this.hasSearch) {
                this.$borderWrapper.removeClass('has-placeholder');
                this.$borderWrapper.removeClass('empty');
                this.$inputWrapper.removeClass('prevent-hover');
                $wrapper = this.$borderWrapper;
            } else {
                this.$inputWrapper.removeClass('has-placeholder');
                this.$inputWrapper.removeClass('empty');
                $wrapper = this.$inputWrapper;
            }
        }

        var val = this.getValue();
        if ($wrapper && containsValues) {
            $wrapper.removeClass('does-not-have-actual-value');
        } else if ($wrapper) {
            $wrapper.addClass('does-not-have-actual-value');
        }
    };

    AutoComplete.prototype.renderStyles = function () {
        if (this.hasSearch) {
            style.renderStyles(this, null, this.$borderWrapper);
            style.renderStyles(this, null, this.$inputWrapper, null, 'input');
        } else {
            style.renderStyles(this, null, this.$inputWrapper);
        }

        if (typeof this.data.styles === 'string') {
            style.renderStyles(this, null, this.$scrollContainer);
            style.renderStyles(this, null, this.$list);
        }

        var tempStyles = this.data.styles;
        var tempType = this.data.type;
        this.data.styles = this.data.gridStyleId;
        this.data.type = 'Grid';

        this.data.styles = tempStyles;
        this.data.type = tempType;
    };

    AutoComplete.prototype.preRender = function () {
        this.tooltip.update();
        this.piping.visibility.apply(this);
        this.piping.required.apply(this);
        Required.prototype.addRemoveRequiredIndicator(this);

        this.$list
            .appendTo($('body'));

        this.subscribeEventHandler(this.piping.$actionWrapper, 'scroll', this.closeItemList.bind(this));
        this.formatter = this.piping.formatting.createFormatter(this.data.formatting);

        this.clearFilterParameter();

        this.applyPosition();

        var self = this;
        if (this.data.dataSource) {
            this.piping.datasources.registerDatasourceListener(this.data.dataSource, function (data) {
                self.update(data, true);
            }, function (params) {
                self.decorateQuery(params);
            });
        }

        this.initialize();
        this.subscribeEventHandler($(window), 'resize', _.debounce(this.renderDropdown.bind(this, true), 50));
    };

    AutoComplete.prototype.decorateQuery = function (params) {
        params.doNotExecuteCountQuery = !!this.data.hideTotal;
        params.page = this.currentPage;
        params.pageSize = this.getPageSize();
    };

    AutoComplete.prototype.getPageSize = function () {
        return this.data.pageSize || 128;
    };

    AutoComplete.prototype.initialize = function () {
        var self = this;

        var enterPressedEvent = this.getEventDataFor('enterPressed');

        this.$inputField
            .on('click',function () {
                if (!self.hasSearch) {
                    if (self.$inputField.val().length)
                        self.openItemList();
                }
            })
            .on('focus', function () {
                self.focused = true;
            })
            .on('keydown', function (e) {
                if (e.which === ARROWDOWN) {
                    self.nextItem();
                } else if (e.which === ARROWUP) {
                    self.previousItem();
                } else if (e.which === ENTER) {
                    if (enterPressedEvent.enabled) {
                        if (self.itemListIsOpen() && self.hasFocusedItem()) {
                            self.selectCurrentItem();
                        } else {
                            self.triggerEvent(enterPressedEvent.raisedEventName);
                        }
                    } else if (self.itemListIsOpen()) {
                        self.selectCurrentItem();
                    }
                } else if (e.which === TAB) {
                    if (self.selectedId === null || self.selectedId === undefined)
                        self.handleFocusLost();

                    if (self.itemListIsOpen()) {
                        // when 'dropdown-with-search' is enabled IE has to handle the blur event first
                        // if we don't do this the focus will be moved to the element with the lowest tabindex
                        // instead of to the element with the next tabindex
                        _.defer(function () {
                            self.getFocusedItem().trigger('mousedown');
                            self.closeItemList();
                        });
                    }
                }
            })
            .on('blur', function () {
                // make sure clicking the scrollbar does not close the popup (IE only?)
                if (!self.keepFocus)
                    self.focused = false;

                setTimeout(function () {
                    if (!self.focused)
                        self.closeItemList();
                });

                if (self.selectedText !== self.$inputField.val())
                    self.handleFocusLost();
                // The value can be changed from there
                if (self.data.behaviour !== 'dropdown-with-search')
                    self.updateEmptyState(self.$inputField.val());
            })
            .on('keyup', function (e) {
                if (e.which === ARROWDOWN || e.which === ARROWUP) {
                    e.preventDefault();
                    return;
                }

                if (e.which === ENTER || e.which === TAB) {
                    e.preventDefault();
                    return;
                }

                if (self.data.filterParameterName)
                    self.piping.parameters.locals.setValue(self.data.filterParameterName, self.$inputField.val());

                self.newSearchDebounced();

                if (!self.hasSearch) {
                    if (self.$inputField.val().length)
                        self.openItemList();
                    else {
                        self.closeItemList();
                        self.clearValue();
                    }
                }

                self.updateRequiredIndicator();
                self.updateEmptyState(self.$inputField.val());
            });

        var onMouseDown = function () {
            if (self.itemListIsOpen()) {
                self.closeItemList();
            } else {
                if (self.numberOfLoadedResults === null) {
                    if (self.selectedItem && self.data.onlyShowSelectedItem) {
                        self.update({
                            results: [self.selectedItem],
                            outputs: self.outputs,
                            totalNumberOfResults: 1
                        }, true);
                        self.openItemList();
                    } else {
                        self.piping.queryDispatcher.dispatch(
                            self.data.dataSource,
                            function (data) {
                                self.update(data, true);
                                self.openItemList();
                            },
                            function (params) {
                                self.currentPage = 0;
                                self.decorateQuery(params);
                            });
                    }
                } else {
                    self.openItemList();
                }
            }
        };

        this.$img
            .on('mousedown', onMouseDown)
            .on('focus', function () {
                self.focused = true;
            })
            .on('blur', function () {
                self.focused = false;
            });

        if (this.hasSearch) {
            this.$displayField
                .on('mousedown', onMouseDown)
                .on('focus', onMouseDown)
                .on('focus', function () {
                    self.$displayField.attr('tabindex', -1);
                    self.$inputField.attr('tabindex', self.data.tabIndex);
                });
            this.$inputField.on('blur', function () {
                self.$inputField.attr('tabindex', -1);
                self.$displayField.attr('tabindex', self.data.tabIndex);
                self.closeItemList();
            });
        }

        this.$list
            .on('focus', function () {
                self.focused = true;
            })
            .on('blur', function () {
                self.focused = false;
                setTimeout(function () {
                    if (!self.focused) {
                        self.closeItemList();

                        if (self.selectedText !== self.$inputField.val())
                            self.clearValue();
                    }
                });
            })
            .on('mousedown', function () {
                self.keepFocus = true;
            });
    };

    AutoComplete.prototype.updateEmptyState = function (val) {
        if (val !== "" && val !== undefined && val !== null) {
            this.tooglePlaceholder(false);
        } else {
            this.tooglePlaceholder(true);
        }
    };

    AutoComplete.prototype.handleFocusLost = function () {
        if (this.data.behaviour === 'dropdown') {
            this.clearValue();
        } else if (this.data.behaviour === 'input') {
            // clear the value (the selected id), but keep the text that was inputted by the user
            this.clearValue(true);
        }

        if (this.data.behaviour !== 'dropdown-with-search') {
            this.results = null;
            this.numberOfLoadedResults = null;
        }
    };

    AutoComplete.prototype.newSearch = function () {
        if (!this.data.dataSource)
            return;

        var queryId = this.queryId = _.uniqueId('autocomplete_');

        var self = this;
        this.piping.queryDispatcher.dispatch(
            this.data.dataSource,
            function (data) {
                if (self.queryId !== queryId)
                    return;
                self.update(data, true, true);
            },
            function (params) {
                self.currentPage = 0;
                self.decorateQuery(params);
            });
    };

    AutoComplete.prototype.focus = function () {
        this.$inputField.trigger('focus');
    };

    AutoComplete.prototype.clearValue = function (keepText) {
        if (!keepText) {
            this.$inputField.val('');
            this.clearFilterParameter();
        }

        if (!this.selectedId)
            return;

        this.$icon.css('background-image', '');
        this.selectedId = null;
        this.selectedItem = null;
        this.selectedText = null;

        this.results = null;
        this.numberOfLoadedResults = null;

        if (this.hasSearch)
            this.$displayField
                .text(this.data.watermark || '')
                .addClass('auto-complete-label-placeholder');

        this.tooglePlaceholder(true);

        this.updateRequiredIndicator();
        this.triggerEventIfEnabled('deselected'); // should happen after the value is cleared in case it is used in a mapping
        this.triggerEventIfEnabled('changed');
    };

    AutoComplete.prototype.setValue = function (update) {
        if (update.value === undefined || update.value === null || update.value === '') {
            this.clearValue();
            return;
        }

        var match = this.findMatchingRowById(update.value);

        if (match) {
            this.selectItem(match);
        } else {
            this.selectedId = update.value; //set selected id anyway, otherwise when you immediately get the current value after setting it, you would always get nothing

            if (this.data.iconColumn)
                this.$icon.css('display', '');

            var self = this;
            if (self.data.useSecondDataSource) {
                self.piping.parameters.locals.setValue(self.data.secondParameter, update.value);
                self.piping.queryDispatcher.dispatch(
                    self.data.secondDataSource,
                    function (result) {
                        self.outputs = result.outputs;
                        self.checkForResults(result, update);
                    });
            } else {
                var data = {
                    actionId: this.piping.actionId,
                    dataSource: this.data.dataSource,
                    parameters: this.piping.parameters.getNonSystemParameters(),
                    filterValues: [{
                        outputAlias: this.data.keyOutputName,
                        value: update.value
                    }]
                };

                self.piping.dispatcher.dispatch(
                    'Query/Find',
                    data,
                    function (result) {
                        self.outputs = result.outputs;
                        self.checkForResults(result, update);
                    });
            }

        }
    };

    AutoComplete.prototype.findMatchingRowById = function (anId) {
        if (this.results && this.results.length !== 0) {
            var self = this;
            return _.find(this.results, function (item) {
                return item[self.data.keyOutputName] === anId;
            });
        }
        return null;
    };

    AutoComplete.prototype.selectItem = function (selectedItem) {
        this.selectedItem = selectedItem;
        this.selectedText = (selectedItem[this.data.outputName] || "").toString();
        this.selectedId = selectedItem[this.data.keyOutputName];

        var img = selectedItem[this.data.iconColumn];
        if (img && img.Url) {
            var imageUrl = dynamicContentImage.getPath({
                    imageName: img.Url,
                    useThumbnail: true,
                    resizeOption: 'fillKeepRatio',
                    thumbnailFileType: 'png'
                });
            var url = 'url(' + imageUrl + ')';
            this.$icon.css('background-image', url);
            this.$icon.css('display', '');
        } else if (img && this.data.iconColumn) {
            var url = 'url(' + img + ')';
            this.$icon.css('background-image', url);
            this.$icon.css('display', '');
        } else {
            this.$icon.css('background-image', '');
        }

        this.tooglePlaceholder(false);
        if (this.hasSearch)
            this.$displayField
                .removeClass('auto-complete-label-placeholder')
                .text(this.selectedText);
        else
            this.$inputField.val(html.strip(this.selectedText));

        this.updateRequiredIndicator();
    };

    AutoComplete.prototype.checkForResults = function (result, update) {
        var self = this;

        if (result.results.length > 0) {
            var addedItem = result.results[0];
            self.selectItem(addedItem);
        } else {
            if (this.data.iconColumn)
                self.$icon.css('display', '');
            self.selectedId = update.value;
            self.$inputField.val('');

            if (self.hasSearch)
                self.$displayField.empty();
        }
    }

    AutoComplete.prototype.update = function (data, isNewSearch) {
        if (data == undefined)
            return;

        this.outputs = data.outputs;

        this.updateAutoCompleteList(isNewSearch, data.results, data.totalNumberOfResults);

        if (this.afterUpdate) {
            this.afterUpdate();
            this.afterUpdate = null;
        }
        this.fetchNextPageIfNeeded();
    };

    AutoComplete.prototype.isValid = function () {
        if (!this.requiredData || this.hasValue())
            return true;
        if (this.data.behaviour === 'input')
            return !!this.$inputField.val();
        return false;
    };

    AutoComplete.prototype.getValue = function () {
        return this.selectedId;
    };

    AutoComplete.prototype.clearFocusedItem = function () {
        this.getFocusedItem().removeClass('focusedItem');
    };

    AutoComplete.prototype.setFocusedItem = function (index) {
        this.clearFocusedItem();
        this.getAllItems().eq(index).addClass('focusedItem');
    };

    AutoComplete.prototype.hasFocusedItem = function () {
        return !!this.$listTable.find('.focusedItem').length;
    };

    AutoComplete.prototype.getFocusedItem = function () {
        return this.$listTable.find('.focusedItem');
    };

    AutoComplete.prototype.getFocusedIndex = function () {
        var focusedItem = this.getFocusedItem();
        return this.getAllItems().index(focusedItem);
    };

    AutoComplete.prototype.getAllItems = function () {
        return this.$listTable.find('tr.item');
    };

    AutoComplete.prototype.nextItem = function () {
        var index = this.getFocusedIndex() + 1;
        if (index >= this.getAllItems().length)
            index = 0;
        this.setFocusedItem(index);

        if (index === 0) {
            this.$scrollContainer.scrollTop(0);
        } else {
            var scrollTopOfContainer = this.$scrollContainer.scrollTop();
            var heightOfContainer = this.$scrollContainer.outerHeight();
            var bottomOfContainer = scrollTopOfContainer + heightOfContainer;

            var $item = this.getFocusedItem();

            var positionTopOfItem = $item.position().top;
            var heightOfItem = $item.outerHeight();
            var positionBottomOfItem = positionTopOfItem + heightOfItem;

            var tryToMakeUpForTheHorizontalScrollbar = 25;
            var bestPosition = positionBottomOfItem + tryToMakeUpForTheHorizontalScrollbar;

            if (bestPosition > scrollTopOfContainer + heightOfContainer)
                this.$scrollContainer.scrollTop(scrollTopOfContainer + (bestPosition - bottomOfContainer));
        }
    };

    AutoComplete.prototype.previousItem = function () {
        var index = this.getFocusedIndex() - 1;
        var movingToTheLastItem = index < 0;
        if (movingToTheLastItem)
            index = this.getAllItems().length - 1;
        this.setFocusedItem(index);

        if (movingToTheLastItem) {
            this.$scrollContainer.scrollTop(this.$scrollContainer.innerHeight());
        } else {
            var scrollTopOfContainer = this.$scrollContainer.scrollTop();

            var $item = this.getFocusedItem();

            var positionTopOfItem = $item.position().top;
            var addABitOfSpacing = 10;
            var bestPosition = positionTopOfItem - addABitOfSpacing;

            if (bestPosition < scrollTopOfContainer)
                this.$scrollContainer.scrollTop(scrollTopOfContainer - (scrollTopOfContainer - bestPosition));
        }
    };

    AutoComplete.prototype.selectCurrentItem = function () {
        this.getFocusedItem().trigger('mousedown');
        this.closeItemList();
    };

    AutoComplete.prototype.updateAutoCompleteList = function (isNewSearch, results, totalNumberOfResults) {
        this.totalNumberOfResults = totalNumberOfResults;

        if (this.data.infiniteScroll)
            this.lastPageReached = results.length < this.getPageSize();

        var headers = {};

        var self = this;
        _.each(this.outputs, function (value, outputName) {
            if (outputName === 'Id' && outputName === self.data.keyOutputName)
                return;
            if (_.contains(self.data.hiddenColumns, outputName))
                return;
            headers[outputName] = value;
        });

        if (isNewSearch) {
            this.$listTable.empty();

            var headerNames = _.keys(headers);

            if (!this.data.hideHeaders && headerNames.length !== 0) {
                var $header = $('<tr />')
                    .addClass('headers')
                    .addClass('prevent-hover')
                    .appendTo(this.$listTable);

                if (typeof this.data.styles !== 'string') {
                    style.renderStyles(this, null, $header, null, 'header');
                }

                _.each(headerNames,
                    function(value) {
                        $header.append($('<th />').text(value));
                    });
            }

            this.numberOfLoadedResults = results.length;

            if (this.selectedItem) {
                var notYetLoaded = _.every(results, function(item) {
                    return item[self.data.keyOutputName] !== self.selectedId;
                });
                if (notYetLoaded) {
                    results.unshift(this.selectedItem);
                    this.numberOfLoadedResults++;
                }
            }
        } else {
            this.numberOfLoadedResults += results.length;

            // the current selection is always shown on the first page
            if (this.selectedItem) {
                var currentSelection = _.find(results, function (item) {
                    return item[self.data.keyOutputName] === self.selectedId;
                });
                if (currentSelection) {
                    var indexOfCurrentSelection = results.indexOf(currentSelection);
                    results.splice(indexOfCurrentSelection, 1);
                    this.numberOfLoadedResults--;
                }
            }
        }

        _.each(results, function (item) {
            var $row = $('<tr class="item" />')
                .on('mousedown', function () {
                    self.selectItem(item);
                    self.closeItemList();

                    self.$listTable
                        .find('.selectedItem')
                        .removeClass('selectedItem');

                    $row.addClass('selectedItem');

                    self.triggerEventIfEnabled('selected', self.selectedId);
                    self.triggerEventIfEnabled('changed', self.selectedId);

                    if (self.data.onlyShowSelectedItem)
                        results = null;
                })
                .appendTo(self.$listTable);

            if (isNewSearch && item[self.data.keyOutputName] === self.selectedId)
                $row.addClass('selectedItem');

            _.each(headers, function (type, key) {
                var cellValue = item[key];
                if (cellValue === undefined || cellValue === null) {
                    cellValue = "";
                }
                var formattedValue = html.strip(self.formatter.convertFromLicquidFormat(type, cellValue));

                if (type === "LicquidDocumentVersionDetail" || key === self.data.iconColumn) {
                    var imgUrl = '';
                    if (type === "LicquidDocumentVersionDetail") {
                        if (cellValue && cellValue.Url) {
                            var url = dynamicContentImage.getPath({
                                imageName: cellValue.Url,
                                useThumbnail: true,
                                resizeOption: 'fillKeepRatio',
                                thumbnailFileType: 'png'
                            });
                            imgUrl = 'url(' + url + ')';
                        }
                    } else if (cellValue) {
                        imgUrl = 'url(' + cellValue + ')';
                    }

                    $row.append(
                        $('<td />')
                            .on('mouseenter', function () {
                                self.$listTable.find('tr').removeClass('focusedItem');
                                $row.addClass('focusedItem');
                            }).append($('<div class = "icon" />')
                            .css({
                                backgroundImage: imgUrl
                            }))
                        );
                } else {
                    $row.append(
                        $('<td />')
                            .on('mouseenter', function () {
                                self.$listTable.find('tr').removeClass('focusedItem');
                                $row.addClass('focusedItem');
                            })
                            .text(formattedValue));
                }
            });
        });

        if (!this.data.hideTotal && $.isNumeric(this.totalNumberOfResults))
            this.$listFooter.text("Loaded " + this.numberOfLoadedResults + " out of " + this.totalNumberOfResults);
        else
            this.$listFooter.text("");

        if (this.itemListIsOpen()) {
            if (this.data.behaviour === 'input') {
                // only preselect an exact match
                var search = self.$inputField.val();
                var result = _.find(results, function(row) {
                    return row[self.data.outputName] === search;
                });
                if (result) {
                    var index = _.indexOf(results, result);
                    this.setFocusedItem(index);
                }
            } else if (!this.hasFocusedItem()) {
                this.setFocusedItem(0);
            }
        }
    };

    AutoComplete.prototype.itemListIsOpen = function () {
        return this.$list.is(':visible');
    };

    AutoComplete.prototype.openItemList = function () {
        this.renderDropdown();
        this.$list.show();
    };

    AutoComplete.prototype.renderDropdown = function (isResizing) {
        if (isResizing && !this.$list.is(':visible'))
            return;
        var left = this.$element.offset().left - this.piping.$app.offset().left;
        var top = this.$element.offset().top - this.piping.$app.offset().top + this.$element.height() + offsetFromInput;
        var width = 0;

        if (this.hasSearch) {
            var width = this.data.popupHasWidth ? this.data.popupWidth : this.$borderWrapper.outerWidth();
        } else {
            var width = this.data.popupHasWidth ? this.data.popupWidth : this.$inputWrapper.outerWidth();
        }
        var availableWidth = this.piping.$app.width() - left;
        if (width > availableWidth)
            left -= (width - availableWidth);

        var borderWidthOfList = this.$list.outerWidth() - this.$list.innerWidth();
        this.$list
            .css({
                top: top,
                left: left,
                width: width - borderWidthOfList,
                zIndex: modals.getZIndexForPopups()
            });

        dropDownsListPositioning.positionList(this.$list, this.$element, offsetFromInput, offsetToTheEdge, defMaxHeight);

        this.$displayField.addClass('auto-complete-open');
        this.$inputWrapper.addClass('auto-complete-open');

        if (this.data.behaviour === 'dropdown' || this.data.behaviour === 'dropdown-with-search') {
            var $selected = this.$list.find('.selectedItem');
            if ($selected.length === 0) {
                this.setFocusedItem(0);
                this.$scrollContainer.scrollTop(0);
            } else {
                $selected.addClass('focusedItem');
                this.$scrollContainer.scrollTop($selected.position().top);
            }
        }

        var self = this;
        setTimeout(function () {
            self.blockInfiniteScroll = false;
            self.fetchNextPageIfNeeded();
            self.$inputField.trigger('focus');
        }, 0);

        this.keepFocus = false;
    };

    AutoComplete.prototype.closeItemList = function () {
        if (!this.itemListIsOpen())
            return;

        this.$list.hide();
        this.$displayField.removeClass('auto-complete-open');
        this.$inputWrapper.removeClass('auto-complete-open');

        this.blockInfiniteScroll = true;
    };

    AutoComplete.prototype.unsubscribeEventHandlers = function () {
        this.$list.remove();

        if (this.data.infiniteScroll) {
            this.$scrollContainer.off('scroll', this.onScroll);
        }
    };

    return AutoComplete;
});
